import globalAxios from 'axios';
import { createRequestFunction, DUMMY_BASE_URL, setSearchParams, toPathString } from './common.js';
import { BaseAPI, BASE_PATH } from './base.js';

/* tslint:disable */
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary GET shop-api/v1/getCustomerType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerType: async (options = {}) => {
            const localVarPath = `/shop-api/v1/getCustomerType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GET shop-api/v1/keycloakId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeycloakIdForLoggedInCustomer: async (options = {}) => {
            const localVarPath = `/shop-api/v1/keycloakId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GET shop-api/v1/keycloakToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeycloakTokenForLoggedInCustomer: async (options = {}) => {
            const localVarPath = `/shop-api/v1/keycloakToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GET shop-api/v1/sid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSid: async (options = {}) => {
            const localVarPath = `/shop-api/v1/sid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary GET shop-api/v1/getCustomerType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerType(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerType(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary GET shop-api/v1/keycloakId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKeycloakIdForLoggedInCustomer(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKeycloakIdForLoggedInCustomer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary GET shop-api/v1/keycloakToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKeycloakTokenForLoggedInCustomer(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKeycloakTokenForLoggedInCustomer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary GET shop-api/v1/sid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSid(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSid(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends BaseAPI {
    /**
     *
     * @summary GET shop-api/v1/getCustomerType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCustomerType(options) {
        return DefaultApiFp(this.configuration).getCustomerType(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary GET shop-api/v1/keycloakId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getKeycloakIdForLoggedInCustomer(options) {
        return DefaultApiFp(this.configuration).getKeycloakIdForLoggedInCustomer(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary GET shop-api/v1/keycloakToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getKeycloakTokenForLoggedInCustomer(options) {
        return DefaultApiFp(this.configuration).getKeycloakTokenForLoggedInCustomer(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary GET shop-api/v1/sid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSid(options) {
        return DefaultApiFp(this.configuration).getSid(options).then((request) => request(this.axios, this.basePath));
    }
}

export { DefaultApi, DefaultApiAxiosParamCreator, DefaultApiFp };
//# sourceMappingURL=api.js.map
